
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class CommonInputMixin extends Vue {
  @Prop({ required: true })
  private name!: string

  @Prop({ default: '' })
  private validatePattern!: string;

  @Prop({ default: null })
  private label!: string | null;

  @Prop({ default: null })
  private hint!: string | null;

  @Prop({ default: false })
  private isWarning!: boolean;

  get isRequired(): boolean {
    return this.validatePattern?.includes("required");
  }

  get isInvalid(): boolean | undefined {
    return this.$validator.flags[this.name]?.invalid && this.$validator.flags[this.name]?.validated;
  }
}
